module.exports = __webpack_public_path__ + "img/1536556181.22f17a1c.jpg";